import React from 'react';
import { ArrowDown, MapPin, Star } from 'lucide-react';
import { Button } from './ui/button';
import { heroImages, shopInfo } from '../mock';

const Hero = () => {
  return (
    <section id="top" className="relative min-h-screen w-full overflow-hidden grain">
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <div
          className="absolute inset-0 slow-zoom bg-cover bg-center"
          style={{ backgroundImage: `url(${heroImages[0]})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-[#0a0a0a]" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-40 pb-24 min-h-screen flex flex-col justify-center">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-px w-12 bg-[#c9a961]" />
          <span className="text-[#c9a961] tracking-[0.35em] text-xs uppercase font-medium">
            Depuis {shopInfo.established} — Ramonville, Toulouse
          </span>
        </div>

        <h1 className="font-display text-6xl md:text-7xl lg:text-[110px] leading-[0.95] text-[#f5efe4] max-w-5xl">
          L’art du <span className="italic text-[#c9a961]">rasage</span>
          <br />& de la coupe précise.
        </h1>

        <p className="mt-8 max-w-xl text-[#c8beab] text-lg leading-relaxed">
          Un salon de barbier où la tradition rencontre la modernité.
          Coupes hommes, dégradés, tailles de barbe et finitions au rasoir
          par une équipe passionnée.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <a href={shopInfo.planityUrl} target="_blank" rel="noreferrer">
            <Button
              size="lg"
              className="bg-[#c9a961] hover:bg-[#d9b972] text-[#0a0a0a] font-semibold text-base px-8 py-6 rounded-none border-0"
            >
              Prendre rendez-vous
            </Button>
          </a>
          <a href="#services">
            <Button
              size="lg"
              variant="outline"
              className="border-[#f5efe4]/30 bg-transparent text-[#f5efe4] hover:bg-[#f5efe4] hover:text-[#0a0a0a] text-base px-8 py-6 rounded-none"
            >
              Voir les prestations
            </Button>
          </a>
        </div>

        {/* Info strip */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl border-t border-[#c9a961]/20 pt-8">
          <div>
            <div className="flex items-center gap-1 text-[#c9a961]">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-[#c9a961]" />
              ))}
            </div>
            <div className="mt-1 text-xs text-[#a8a29e]">
              {shopInfo.rating}/5 – {shopInfo.reviewsCount} avis
            </div>
          </div>
          <div>
            <div className="font-display text-2xl text-[#f5efe4]">15+</div>
            <div className="text-xs text-[#a8a29e] uppercase tracking-widest">ans d’expérience</div>
          </div>
          <div>
            <div className="font-display text-2xl text-[#f5efe4]">5</div>
            <div className="text-xs text-[#a8a29e] uppercase tracking-widest">barbiers experts</div>
          </div>
          <div className="flex items-start gap-2">
            <MapPin className="w-4 h-4 text-[#c9a961] mt-1 shrink-0" />
            <div>
              <div className="text-sm text-[#f5efe4] leading-tight">271 Rte de Narbonne</div>
              <div className="text-xs text-[#a8a29e]">31400 Toulouse</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <a
        href="#salon"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2 text-[#c9a961] hover:text-[#f5efe4] transition-colors"
      >
        <span className="text-[10px] tracking-[0.4em] uppercase">Découvrir</span>
        <ArrowDown className="w-4 h-4 animate-bounce" />
      </a>
    </section>
  );
};

export default Hero;
